declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export type RegisterClickParams = {
  section: string;
  linkLabel?: string;
};

export function trackRegisterClick({ section, linkLabel }: RegisterClickParams) {
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', 'register_click', {
    section,
    link_label: linkLabel ?? '',
  });
}
